import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import EntryPage        from './pages/EntryPage';
import RoomPage         from './pages/RoomPage';
import LoginPage        from './pages/LoginPage';
import DjPortalPage     from './pages/DjPortalPage';
import AdminPage        from './pages/AdminPage';
import { api } from './services/api';

function RequireAdmin({ children }) {
  return api.isAdmin() ? children : <Navigate to="/login?role=admin" replace />;
}
function RequireDj({ children }) {
  return api.isDj() ? children : <Navigate to="/login?role=dj" replace />;
}

export default function App() {
  return (
    <BrowserRouter basename="/muzon">
      <Routes>
        <Route path="/"            element={<EntryPage />} />
        <Route path="/room/:code"  element={<RoomPage />} />
        <Route path="/login"       element={<LoginPage />} />
        <Route path="/dj"          element={<RequireDj><DjPortalPage /></RequireDj>} />
        <Route path="/admin"       element={<RequireAdmin><AdminPage /></RequireAdmin>} />
        <Route path="*"            element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
